export enum WarningType {
  FUNNEL_TO_STANDARD = 'funnelToStandard',
  FUNNEL_TO_MILESTONE = 'funnelToMilestone',
  MILESTONE_TO_STANDARD = 'milestoneToStandard',
  MILESTONE_TO_FUNNEL = 'milestoneToFunnel',
  PHASE_DELETE = 'phaseDelete',
  MILESTONE_DELETE = 'milestoneDelete'
}
